module.exports = __webpack_public_path__ + "img/36979-099.9e179254.jpg";